import { ContextColumnsBase } from "@mwt/web-js-telemetry";
import {
  updateLoggingContext,
  getBrowserLocale,
  CustomContextColumns,
} from "@smb/web-telemetry";

import { environment } from "../../environments/environment";

export const updateLoggerContext = () => {
  updateLoggingContext(
    { [ContextColumnsBase.UserInfoLanguage]: getBrowserLocale() },
    {
      [CustomContextColumns.AppName]: environment.appName,
      [ContextColumnsBase.AppInfoEnvironment]: environment.appEnv,
    }
  );
};
